export default "__VITE_ASSET__DCxpZz52__"